module.exports = __webpack_public_path__ + "img/7.a7875690.png";